const inputRestriction = {
  none: 0,
  numbersOnly: 1,
  nonNegativeFloat: 2,
  phoneNumber: 3,
  zeroTo9999Float: 4,
  zeroTo99Float: 5,
  nonNegativeFloatDecimalLimit: 9,
};

export default inputRestriction;
